import React, {useState} from 'react'
import { Grid, makeStyles, Popover, Typography } from '@material-ui/core'
import { grey } from '@material-ui/core/colors'
import cx from 'classnames'

const useStyles = makeStyles(theme => ({
    root:{
        background:'white',
        boxShadow:'0px 4px 8px rgba(102, 102, 102, 0.1)',
        padding:'6px 20px',
        borderRadius:26,
        '&:hover':{
            cursor:'pointer'
        }
    },
    icon:{
        color:theme.palette.primary.main,
        marginTop:4
    },
    subtitle:{
        paddingLeft:0,
        paddingBottom:0,
        color:theme.palette.primary.main
    },
    popper:{
        marginTop:8,
        padding:'16px 8px',
        paddingLeft:0,
        borderRadius:32,
        minWidth:200,
        boxSizing:'border-box',
        overflow:'hidden'
    },
    container:{
        maxHeight:250,
        overflowX:'hidden',
        overflowY:'auto',
        
    },
    item:{
        fontFamily: theme.typography.fontFamily,
        padding:"12px 16px",
        borderTop:`1px solid ${grey[200]}`,
        '&:hover':{
            cursor:'pointer',
            background:grey[100]
        }
    },
    selected:{
        fontWeight:500
    },
    color:{
        display:'flex',
       
    }
}))

const GenericStatusEditable = props => {
    const classes = useStyles()
    const { options, selected, onChange, log, color } = props

    const [anchorEl, setAnchorEl] = useState(null)

    let selectedItem = options.find(el => el.value === selected)


    const onInnerChange = (id) =>{
        setAnchorEl(null)
        onChange(id)
    }
    if(log){
        console.log(`Value: ${selected}`)
        console.log(`Options: ${JSON.stringify(options)}`)
        console.log(`Filter: ${selectedItem}`)
    }

    return(
        <div>
            <Popover classes={{paper:classes.popper}} open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={(e) => setAnchorEl(null)} anchorOrigin={{vertical: 'bottom',horizontal: 'left'}} transformOrigin={{vertical: 'top',horizontal: 'left'}} >
                <div className={classes.container} >
                    {options.map((item,key)=>{
                        return(
                            <div key={key.toString()} className={cx({
                                [classes.item]:true,
                                [classes.selected]: selected === item.value,
                                [classes.color]:color
                            })} onClick={() => onInnerChange(item.value)}>
                                {color ? <div style={{background:item.color, width:10, height:10, borderRadius:'50%', marginTop:4, marginRight:8 }} ></div> : null}
                                {item.label}
                            </div>
                        )
                    })}
                </div>
            </Popover>
            <div className={classes.root} onClick={(e) => setAnchorEl(e.currentTarget)}>
                <Grid container alignItems='center' spacing={1} wrap='nowrap'>
                    {color ? <Grid item><div style={{background:selectedItem ? selectedItem.color : grey[300], width:10, height:10, borderRadius:'50%', marginTop:4, marginRight:8 }} ></div></Grid> : null}
                    <Grid item>
                        <Typography variant='body2' noWrap>{selectedItem ? selectedItem.label : null}</Typography>
                    </Grid>
                </Grid>
            </div>
        </div>
        
    )
}

export default GenericStatusEditable